import { trigger, state, style, transition, animate } from '@angular/animations'

export const fadeOutThenInAnimation = trigger('fadeOutThenInAnimation', [
  state('Shown', style({ opacity: '1' })),
  state('NotShown', style({ opacity: '0' })),
  transition('* => *', [animate('.3s')]),
])
